var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappTemplateMarketingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161013",
    "data-name": "Group 161013",
    transform: "translate(-268 -263)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2175",
    "data-name": "Rectangle 2175",
    width: 30,
    height: 30,
    rx: 4,
    transform: "translate(268 263)",
    fill: "#c9e7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "marketing-svgrepo-com",
    d: "M11.238,2.058a.986.986,0,0,0-.923-.079L5.45,3.9a.962.962,0,0,1-.363.071H1.972a.986.986,0,0,0-.986.986v.079H0V7.4H.986v.1a.986.986,0,0,0,.986.962l1.183,2.508a.994.994,0,0,0,.891.568h.5a.986.986,0,0,0,.978-.986v-2l4.8,1.916a1,1,0,0,0,.371.071,1.017,1.017,0,0,0,.552-.174.986.986,0,0,0,.434-.789V2.87a.986.986,0,0,0-.434-.812Zm-6.7,2.894V7.5H1.972V4.952Zm0,5.6h-.5l-.97-2.09H4.535ZM5.812,7.618A1.806,1.806,0,0,0,5.521,7.5V4.9a1.782,1.782,0,0,0,.292-.087l4.874-1.94V9.558ZM11.7,5.228V7.2a.986.986,0,0,0,0-1.972Z",
    transform: "translate(276.659 272.1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappTemplateMarketingIcon);
export default __webpack_public_path__ + "static/media/whatsapp-template-marketing-icon.dc82390aef38921a21524f3e4fd0a3b1.svg";
export { ForwardRef as ReactComponent };